module.exports = __webpack_public_path__ + "img/step1-desktop.30824beb.jpg";